interface ChipGroupProps {
  label: string
  options: string[]
  /** Single-select: value/onChange. Multi-select: values/onToggle. */
  value?: string
  onChange?: (value: string) => void
  values?: string[]
  onToggle?: (value: string) => void
  /** Adds the asterisk. A chip group has no input to carry the native `required`. */
  required?: boolean
}

export function ChipGroup({ label, options, value, onChange, values, onToggle, required }: ChipGroupProps) {
  const isMulti = !!onToggle
  return (
    <div>
      <span className={`label ${required ? 'label-required' : ''}`}>{label}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const active = isMulti ? (values ?? []).includes(opt) : value === opt
          return (
            <button
              key={opt}
              type="button"
              onClick={() => (isMulti ? onToggle?.(opt) : onChange?.(opt))}
              className={`chip ${active ? 'chip-active' : ''}`}
            >
              {opt}
            </button>
          )
        })}
      </div>
    </div>
  )
}
